@let selectedEmployees = selectedEmployeesSg();
@let employees = employeesSg();
@let isSubmitting =
  ecSg().plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<atn-ds-centered-overlay type="wide">
  <div class="atn-space-occupants-modal">
    <atn-ds-widget title="Add Occupant">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-occupants-modal__content">
        <atn-space-modal-employee-selector
          [employees]="employees"
          [selectedEmployees]="selectedEmployees"
          (employeeToggled)="
            employeeCheckboxChangedHandler($event.id, $event.selected)
          "
          (employeeRemoved)="removeSelectedEmployee($event)"
        />
        <ng-content />
      </div>

      <div
        class="atn-space-occupants-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          (click)="saveClickHandler()"
          [disabled]="!selectedEmployees.length"
          [loading]="isSubmitting"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
